import React from 'react';
import { motion } from 'framer-motion';
import { useGentleMotion as useReducedMotion } from '../hooks/useGentleMotion';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { Doodles, DoodleSpec } from './Doodles';
import { forWhom } from '../data/content';
const accents = ['#2D8C5A', '#6CBBD5', '#F3A340', '#F27C70', '#F6C453', '#8E7CC3'];
const doodles: DoodleSpec[] = [{
  kind: 'star',
  top: '8%',
  left: '4%',
  size: 22,
  color: '#F6C453',
  rotate: -10
}, {
  kind: 'squiggle',
  top: '16%',
  left: '91%',
  size: 32,
  color: '#6CBBD5'
}, {
  kind: 'dot',
  top: '78%',
  left: '7%',
  size: 10,
  color: '#F27C70'
}, {
  kind: 'crayon',
  top: '84%',
  left: '93%',
  size: 26,
  color: '#2D8C5A',
  rotate: 16
}];
export function ForWhom() {
  const reduce = useReducedMotion();
  return <section className="relative w-full overflow-hidden bg-cream py-16 sm:py-20" aria-labelledby="forwhom-title" data-id="element-168" data-mp="is4zbhuqu037">
      <Doodles specs={doodles} data-id="element-169" data-mp="dzby33yhh9vv" />

      <div className="relative mx-auto max-w-content px-5 sm:px-8" data-id="element-170" data-mp="dz3j96isvui1">
        <Reveal data-id="element-171" data-mp="1p4znhu5bqizi">
          <h2 id="forwhom-title" className="mx-auto max-w-2xl text-center font-display text-2xl font-extrabold uppercase leading-tight text-navy sm:text-4xl" data-id="element-172" data-mp="1p6ki1jrn21xd">
            El Gran Reto Creativo es para{' '}
            <span className="text-coral" data-id="element-173" data-mp="1kd7yho1tglbh">tu familia</span> si...
          </h2>
        </Reveal>

        <ul className="mx-auto mt-10 grid max-w-4xl grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-174" data-mp="15fyyy72d0b8o">
          {forWhom.map((item, i) => <Reveal as="li" key={item} delay={i * 0.05} data-id="element-175" data-mp="1agcz72xpygw5" data-mpi={i}>
              <div className="flex h-full items-start gap-3 rounded-2xl bg-white p-5 shadow-soft transition-transform duration-300 hover:-translate-y-1 motion-reduce:transition-none motion-reduce:hover:translate-y-0" style={{
            borderLeft: `5px solid ${accents[i % accents.length]}`
          }} data-id="element-176" data-mp="wg257r144m6r">
                <motion.span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full" style={{
              backgroundColor: `${accents[i % accents.length]}26`
            }} animate={reduce ? undefined : {
              scale: [1, 1.14, 1]
            }} transition={{
              duration: 3,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: i * 0.3
            }} data-id="element-177" data-mp="2vrv7o36o6jqv">
                  <CheckIcon className="h-3.5 w-3.5" style={{
                color: accents[i % accents.length]
              }} aria-hidden="true" data-id="element-178" data-mp="3d179nvidxudq" />
                </motion.span>
                <p className="font-sans text-sm leading-relaxed text-ink sm:text-[0.95rem]" data-id="element-179" data-mp="33akug2ekz5vk">
                  {item}
                </p>
              </div>
            </Reveal>)}
        </ul>

        <Reveal delay={0.15} data-id="element-180" data-mp="3vut8j308tvse">
          <motion.div className="mx-auto mt-10 max-w-2xl rounded-3xl border-2 border-sun bg-cream2 p-6 text-center sm:p-8" animate={reduce ? undefined : {
          y: [0, -6, 0]
        }} transition={{
          duration: 6,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-181" data-mp="3r29w49dal6p6">
            <p className="font-display text-lg font-extrabold uppercase leading-tight text-navy sm:text-2xl" data-id="element-182" data-mp="c5y3l1ymfb95">
              No necesitas ser experta en manualidades.
            </p>
            <p className="mt-2 font-sans text-sm text-muted sm:text-base" data-id="element-183" data-mp="h2yb7hb4cm2d">
              Solo abre la guía, elige una actividad y empieza.
            </p>
          </motion.div>
        </Reveal>
      </div>
    </section>;
}